import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { mergeRegister } from "@lexical/utils";
import { FOCUS_COMMAND, COMMAND_PRIORITY_LOW } from "lexical";
import { useEffect } from "react";

interface Props {
  enabled?: boolean;
  onFocus: () => void;
}

const HtmlOnFocusPlugin = (props: Props) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return mergeRegister(
      editor.registerCommand(
        FOCUS_COMMAND,
        () => {
          if (props.enabled ?? true) {
            props.onFocus();
          }

          return false;
        },
        COMMAND_PRIORITY_LOW
      )
    );
  }, [editor, props]);

  return null;
};

export { HtmlOnFocusPlugin };
